// eslint-disable-next-line import/prefer-default-export
export var validateEmail = function validateEmail(email) {
  return (
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    // eslint-disable-line
    email)
  );
};